module.exports = __webpack_public_path__ + "static/media/copilot-cert-full.76c34e2a.png";